<template>
    <div>
        <AdaButton type="pink" :custom-styles="{width: 'fit-content'}"
                   :loading="$store.state.deals.missingDealIds === null"
                   :title="'Fehlende Deal IDs: ' +($store.state.deals.missingDealIds ? $store.state.deals.missingDealIds.length: '')"
                   icon="exclamation-triangle"
                   :unicon="true"
                   @click="showMissingDealsDialog = true"
                   v-tooltip.bottom="'Deal IDs anzeigen, die nicht in der Dealliste aufgeführt sind'"></AdaButton>
        <Dialog :has-backdrop="true" :show-close-button="true" :show="showMissingDealsDialog"
                @close="showMissingDealsDialog = !showMissingDealsDialog">
            <div :style="{maxHeight:'80vh', minHeight:'620px', overflowY:'auto', padding:'0 15px'}">
                <h4>Fehlende Deal IDs</h4>
                <p>Dies ist eine Liste von Deal IDs, die nicht in der Dealliste angelegt sind. Diese Deals werden
                    daher nicht in der Übersicht, Presets usw. angezeigt und demnach im Deal Monitoring Tool
                    ignoriert.</p>

                <AdaTableClient :columns="columns" :rows="$store.state.deals.missingDealIds"
                                :transformers="transformers"
                                @rowClicked="rowClicked"
                                no-data="Keine fehlenden Deal IDs gefunden :)"
                ></AdaTableClient>
            </div>
        </Dialog>
    </div>
</template>

<script>
import AdaTableClient from "@/components/dataTable/AdaTableClient";
import AdaButton from "@/components/buttons/AdaButton";
import Dialog from "@/components/dialogs/Dialog";
import moment from "moment";

export default {

    name: "MissingDeals",
    components: {Dialog, AdaButton, AdaTableClient},
    data: () => ({
        showMissingDealsDialog: false,
        columns: [{
            label: 'Deal ID',
            name: 'deal_id',
            type: 'naturalNumber'
        }, {
            label: 'Dealname',
            name: 'deal_name'
        }, {
            label: 'SSP',
            name: 'ssp'
        }, {
            label: 'Datum',
            name: 'date',
            type: 'date'
        }],
        transformers: [
            {
                propName: 'date',
                transform: function (value) {
                    let res = '';
                    if (typeof value !== "undefined") {
                        res = moment(value, moment.ISO_8601).format('DD.MM.YYYY');
                    }
                    return res;
                }
            },
        ],
    }),
    methods: {
        rowClicked(data) {
            console.log(data);
        }
    }
}
</script>

<style scoped>

</style>